/**
 * Brand Guard Component
 *
 * Route-level guard that redirects when the current route
 * is not accessible for the current brand type (GROUP, POINT_OF_SALE, CENTRAL).
 * Reads from the centralized ROUTE_ACCESS config.
 */

import { Navigate, useLocation } from 'react-router-dom';
import { useBrandContext } from '@/hooks';
import { isRouteAccessible, getDefaultRoute } from '@/config/route-access';

interface BrandGuardProps {
  children: React.ReactNode;
}

export function BrandGuard({ children }: BrandGuardProps) {
  const { brandType } = useBrandContext();
  const { pathname } = useLocation();

  if (!isRouteAccessible(pathname, brandType)) {
    return <Navigate to={getDefaultRoute(brandType ?? 'POINT_OF_SALE')} replace />;
  }

  return <>{children}</>;
}
